import { Card } from "primereact/card";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { RadioButton } from "primereact/radiobutton";
import { Tooltip } from "primereact/tooltip";

const CheckoutDeliverySection = ({
  delivery,
  selectedSucursal,
  selectedAlmacen,
}) => {
  const {
    deliveryMethod,
    handleDeliveryMethodChange,
    defaultDeliveryAddress,
    isChangingDeliveryAddress,
    handleChangeDeliveryAddressToggle,
    deliverySaveLoading,
    deliveryAddressParts,
    handleDeliveryAddressPartChange,
    handleResolveDeliveryCoordinates,
    areDeliveryInputsDisabled,
    deliveryCommuneCode,
    deliveryCommuneOptions,
    handleDeliveryCommuneChange,
    deliveryComunasLoading,
    deliveryComunasError,
    deliveryCityLoading,
    deliveryCity,
    deliveryGeoLoading,
    deliveryGeoError,
    debouncedDeliveryMapQuery,
    pickupContactName,
    pickupContactRut,
    pickupVehiclePlate,
    deliveryObservations,
    handleObservationsChange,
    rutError,
    plateError,
    handlePickupFieldChange,
  } = delivery;

  return (
    <Card className="getnet-card-section">
      <h2>Entrega</h2>

      <Tooltip target=".getnet-pickup-tooltip" />
      <Tooltip target=".getnet-delivery-tooltip" />

      <div className="getnet-stack">
        <Card className="getnet-delivery-card">
          <div className="flex align-items-center gap-2">
            <RadioButton
              inputId="getnet-pickup-method"
              name="getnet-delivery-method"
              value="pickup"
              checked={deliveryMethod === "pickup"}
              onChange={(event) => handleDeliveryMethodChange(event.value)}
            />
            <label htmlFor="getnet-pickup-method" className="getnet-method-label">
              <strong className="getnet-method-title">Retiro local <i className="pi pi-info-circle getnet-pickup-tooltip" data-pr-tooltip="Verifica que tu transporte sea apto para productos sobre 3 metros de largo según Ley de Tránsito N°18.290. De no cumplir con la normativa, el material no podrá ser cargado."/></strong>
            </label>
          </div>

          <label htmlFor="getnet-pickup-method" className="getnet-method-label">
            <p>Retiro disponible en 2 a 72 hrs hábiles según disponibilidad. Disponible para retiro en {selectedAlmacen || ""} - {selectedSucursal || ""}, previa confirmación de stock.</p>
          </label>

          {deliveryMethod === "pickup" && (
            <div className="getnet-form-grid mt-3">
              <div className="getnet-field">
                <label htmlFor="getnet-pickup-name">Nombre</label>
                <InputText
                  id="getnet-pickup-name"
                  value={pickupContactName}
                  className="p-inputtext-sm getnet-input-shell"
                  onChange={(event) => handlePickupFieldChange("name", event.target.value)}
                  placeholder="Nombre de quien retira"
                />
              </div>

              <div className="getnet-field">
                <label htmlFor="getnet-pickup-rut">RUT</label>
                <InputText
                  id="getnet-pickup-rut"
                  value={pickupContactRut}
                  className={`p-inputtext-sm getnet-input-shell ${rutError ? "p-invalid" : ""}`.trim()}
                  onChange={(event) => handlePickupFieldChange("rut", event.target.value)}
                  placeholder="Ej: 12.345.678-9"
                />
                {rutError ? <small className="getnet-error-message">{rutError}</small> : null}
              </div>

              <div className="getnet-field">
                <label htmlFor="getnet-pickup-plate">Patente</label>
                <InputText
                  id="getnet-pickup-plate"
                  value={pickupVehiclePlate}
                  className={`p-inputtext-sm getnet-input-shell ${plateError ? "p-invalid" : ""}`.trim()}
                  onChange={(event) => handlePickupFieldChange("plate", event.target.value)}
                  placeholder="Ej: XXXX12"
                />
                {plateError ? <small className="getnet-error-message">{plateError}</small> : null}
              </div>
            </div>
          )}
        </Card>

        <Card className="getnet-delivery-card">
          <div className="flex align-items-center gap-2">
            <RadioButton
              inputId="getnet-delivery-method"
              name="getnet-delivery-method"
              value="delivery"
              checked={deliveryMethod === "delivery"}
              onChange={(event) => handleDeliveryMethodChange(event.value)}
            />
            <label htmlFor="getnet-delivery-method" className="getnet-method-label">
              <strong className="getnet-method-title">Despacho a domicilio</strong>
            </label>
            <i
              className="pi pi-info-circle getnet-delivery-tooltip"
              data-pr-tooltip="La descarga del material es responsabilidad del cliente."
              style={{ color: "var(--primary-color)", cursor: "pointer", fontSize: "0.9rem" }}
            />
          </div>
          <label htmlFor="getnet-delivery-method" className="getnet-method-label">
            <p>Entrega estimada en 48 hrs hábiles.</p>

          </label>
        </Card>

        {deliveryMethod === "delivery" ? (
          <Card className="getnet-delivery-map-card">
            {defaultDeliveryAddress ? (
              <div className="getnet-saved-addresses">
                <span className="getnet-saved-addresses-title">Dirección guardada del cliente</span>
                <div className="getnet-field mt-3">
                  <div className="flex align-items-center gap-2">
                    <Checkbox
                      inputId="getnet-change-delivery-address"
                      checked={isChangingDeliveryAddress}
                      onChange={(event) => handleChangeDeliveryAddressToggle(Boolean(event.checked))}
                      disabled={deliverySaveLoading}
                    />
                    <label htmlFor="getnet-change-delivery-address">Cambiar dirección de despacho</label>
                  </div>
                </div>
              </div>
            ) : null}

            <div className="getnet-map-coordinates-grid">
              <div className="getnet-field full-width">
                <label htmlFor="getnet-delivery-address">Direccion</label>
                <InputText
                  id="getnet-delivery-address"
                  value={deliveryAddressParts.address}
                  className="p-inputtext-sm getnet-input-shell"
                  onChange={(event) => handleDeliveryAddressPartChange("address", event.target.value)}
                  onBlur={handleResolveDeliveryCoordinates}
                  placeholder="Ej: Av. Apoquindo 4501"
                  disabled={areDeliveryInputsDisabled}
                />
              </div>

              <div className="getnet-field">
                <label htmlFor="getnet-delivery-commune">Comuna</label>
                <Dropdown
                  id="getnet-delivery-commune"
                  value={deliveryCommuneCode}
                  options={deliveryCommuneOptions}
                  onChange={handleDeliveryCommuneChange}
                  placeholder={deliveryComunasLoading ? "Cargando comunas..." : "Selecciona una comuna"}
                  showClear
                  filter
                  className="getnet-contact-dropdown"
                  disabled={areDeliveryInputsDisabled}
                />
                {deliveryComunasError ? <small className="getnet-error-message">{deliveryComunasError}</small> : null}
              </div>

              <div className="getnet-field">
                <label htmlFor="getnet-delivery-city">Ciudad</label>
                <InputText
                  id="getnet-delivery-city"
                  value={deliveryCityLoading ? "Cargando ciudad..." : (deliveryCity || "-")}
                  className="p-inputtext-sm getnet-input-shell"
                  disabled
                />
              </div>

              <div className="getnet-field">
                <label htmlFor="getnet-delivery-reference">Referencia</label>
                <InputText
                  id="getnet-delivery-reference"
                  value={deliveryAddressParts.reference}
                  className="p-inputtext-sm getnet-input-shell"
                  onChange={(event) => handleDeliveryAddressPartChange("reference", event.target.value)}
                  onBlur={handleResolveDeliveryCoordinates}
                  placeholder="Ej: Casa, Depto. , Nro.#"
                  disabled={areDeliveryInputsDisabled}
                />
              </div>
            </div>

            {deliveryGeoLoading ? <small className="getnet-map-help">Buscando coordenadas...</small> : null}
            {deliveryGeoError ? <small className="getnet-error-message">{deliveryGeoError}</small> : null}

            <div className="getnet-delivery-map-shell">
              {debouncedDeliveryMapQuery ? (
                <iframe
                  title="Mapa de despacho"
                  src={`https://www.google.com/maps?q=${debouncedDeliveryMapQuery}&z=16&output=embed`}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              ) : (
                <div className="getnet-delivery-map-placeholder">
                  Ingresa una direccion para mostrarla en el mapa.
                </div>
              )}
            </div>

            {debouncedDeliveryMapQuery ? (
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${debouncedDeliveryMapQuery}`}
                target="_blank"
                rel="noreferrer noopener"
                className="getnet-map-link"
              >
                Abrir en Google Maps
              </a>
            ) : null}
          </Card>
        ) : null}

        <div className="getnet-field mt-3">
          <label htmlFor="getnet-delivery-observations">Observaciones</label>
          <InputTextarea
            id="getnet-delivery-observations"
            value={deliveryObservations}
            className="p-inputtext-sm getnet-input-shell"
            onChange={(event) => handleObservationsChange(event.target.value)}
            rows={3}
            placeholder="Instrucciones adicionales para la entrega o retiro"
          />
        </div>
      </div>
    </Card>
  );
};

export default CheckoutDeliverySection;